import React, { useEffect, useRef, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import Webcam from "react-webcam";
import QRCode from "react-qr-code";
import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import IDTier2 from "./IDTier2";

import { Box, Grid, Typography, alpha, Divider } from "@mui/material";
import { useSelector } from "react-redux";
import { validateFile, validateFilePNGJPEG } from ".";
import ModalContent from "../../Common/Modal";
import { ContainedButton } from "../../Common/Buttons";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import QrCodeOutlinedIcon from "@mui/icons-material/QrCodeOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";

const IdentityVerificationPAN = ({
  handleSteps,
  handleBack,
  userDetails,
  steps,
  payload,
  setIsloading,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    watch,
    trigger,
    setValue,
  } = useForm({ mode: "onChange" });
  const { btncolor } = useSelector((state) => state);
  const uuid = localStorage.getItem("uuid");
  const theme = localStorage.getItem("theme");
  const token = localStorage.getItem("access_token");
  const [image, setImage] = useState(null);
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  const [show, setShow] = useState(false);
  const [showQR, setShowQR] = useState(false);
  const [count, setCount] = useState(300);
  const [twoFactorAuthKey, setTwoFactorAuthKey] = useState("");
  const [faceDetected, setFaceDetected] = useState(true);
  const [lastDetectedTime, setLastDetectedTime] = useState(Date.now());
  const { brokerBasicInfo, brokerDetailedInfo } = useSelector((state) => state);
  const handleClose = () => setShow(false);
  const handleCloseQRModal = () => (setShowQR(false), setCount(200));

  const loadModels = async () => {
    const MODEL_URL = "/models";
    await window.faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL);
    await window.faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL);
  };

  const detectFace = useCallback(async () => {
    if (webcamRef.current && webcamRef.current.video.readyState === 4) {
      const video = webcamRef.current.video;
      const detections = await window.faceapi
        .detectAllFaces(video, new window.faceapi.TinyFaceDetectorOptions())
        .withFaceLandmarks();

      const canvas = canvasRef.current;
      if (canvas) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const displaySize = { width: video.videoWidth, height: video.videoHeight };
        window.faceapi.matchDimensions(canvas, displaySize);
        const resizedDetections = window.faceapi.resizeResults(detections, displaySize);
        canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
        window.faceapi.draw.drawDetections(canvas, resizedDetections);
        window.faceapi.draw.drawFaceLandmarks(canvas, resizedDetections);
      }

      if (detections.length > 0) {
        setFaceDetected(true);
        setLastDetectedTime(Date.now());
      } else {
        const timeSinceLastDetection = Date.now() - lastDetectedTime;
        if (timeSinceLastDetection > 2000) setFaceDetected(false);
      }
    }
  }, [lastDetectedTime]);

  useEffect(() => {
    loadModels();
    const interval = setInterval(detectFace, 300);
    return () => clearInterval(interval);
  }, [detectFace]);

  useEffect(() => {
    if (showQR) {
      if (count > 0) {
        const timer = setInterval(() => {
          setCount((prevCountdown) => prevCountdown - 1);
        }, 1000);
        return () => clearInterval(timer);
      }
    }
  }, [count, showQR]);

  const capturePhoto = () => {
    if (webcamRef.current) {
      const capturedImage = webcamRef.current.getScreenshot();
      if (
        !capturedImage.startsWith("data:image/jpeg") ||
        !capturedImage.startsWith("data:image/jpg") ||
        !capturedImage.startsWith("data:image/png")
      ) {
        setImage(capturedImage);
      } else {
        showToast("error", "Only PNG, JPEG, or JPG images are allowed.");
      }
    }
  };

  console.log("userphoto", watch("userPhoto"));

  const onSubmit = async (data) => {
    console.log("Form Data:", data);
    const user = {
      firstName: userDetails?.firstName,
      middleName: userDetails?.middleName,
      lastName: userDetails?.lastName,
      address: userDetails?.address,
      city: userDetails?.city,
      state: userDetails?.state,
      country: userDetails?.country,
      zip: userDetails?.zip,
      uuid: userDetails?.uuid,
      userDocsStatus: "0",
      dob: userDetails?.dob,
      ssn: userDetails?.ssn,
      birthPlace: userDetails?.birthPlace,
      industry: userDetails?.industry,
      occupation: userDetails?.occupation,
      sourcesOfFunds: userDetails?.sourcesOfFunds,
      txnVolumeId: userDetails?.txnVolumeId,
      annualIncomeId: userDetails?.annualIncomeId,
      netWorthId: userDetails?.netWorthId,
      empCategory: userDetails?.empCategory,
      empType: userDetails?.empType,
      pep: userDetails?.pep,
      bankingPartner: userDetails?.bankingPartner,
      relationWithBank: userDetails?.relationWithBank,
      accountPurpose: userDetails?.accountPurpose,
      thirdParty: userDetails?.thirdParty,
    };

    const formData = new FormData();
    formData.append(
      "userPhoto",
      image ? dataURItoBlob(image) : data?.userPhoto[0],
      "userPhoto.png"
    );
    {
      (userDetails?.country === "India" || userDetails?.country === "IN") &&
        formData.append("panFront", data?.panCardPhoto[0]);
    }

    if (userDetails?.country === "India" || userDetails?.country === "IN") {
      user.panNo = data?.panNumber;
    }

    formData.append("addressProof", payload?.addressProof);
    formData.append("idProofBack", payload?.idProofBack);
    formData.append("idProofFront", payload?.idProofFront);
    formData.append("user", JSON.stringify(user));
    setIsloading(true);
    try {
      const response = await axios.post(
        `${WEBSERVICE}user/addUserKYCDetails`,
        formData,
        { headers: { Authorization: `BEARER ${token}` } }
      );
      if (response?.data?.error?.error_data === 0) {
        setIsloading(false);
        callFinishKyc();
      } else {
        setIsloading(false);
        showToast("error", response?.data?.error?.error_msg);
      }
    } catch (error) {
      setIsloading(false);
      showToast("error", error?.response?.data?.error?.error_msg);
    }
  };

  useEffect(() => {
    let interval;
    if (showQR) { interval = setInterval(getUserPhotoFromApi, 1000); }
    return () => { if (interval) clearInterval(interval); };
  }, [showQR]);

  const callFinishKyc = () => {
    const identityObj = {};
    const jsonString = JSON.stringify(identityObj);
    const uuid = localStorage.getItem("uuid");
    const token = localStorage.getItem("access_token");

    axios
      .post(`${WEBSERVICE}user/finishKyc?uuid=${uuid}`, jsonString, {
        headers: { "Content-Type": "application/json", authorization: "BEARER " + token },
      })
      .then((response) => {
        const result = response.data;
        if (result.error?.error_data) {
          showToast("error", result.error.error_msg);
        } else {
          showToast("success", "Your KYC process has been completed");
          setTimeout(() => { window.location.reload(); }, 1000);
        }
      })
      .catch((error) => {
        console.error("Error finishing KYC:", error);
        showToast("error", "Something went wrong.");
      });
  };

  const dataURItoBlob = (dataURI) => {
    var byteString;
    if (dataURI.toString().split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.toString().split(",")[1]);
    else byteString = unescape(dataURI.toString().split(",")[1]);
    var mimeString = dataURI.toString().split(",")[0].split(":")[1].split(";")[0];
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) { ia[i] = byteString.charCodeAt(i); }
    return new Blob([ia], { type: mimeString });
  };

  const validate = () => {
    let valid = false;
    const isIndian = userDetails?.country === "India" || userDetails?.country === "IN";
    if (isIndian) {
      const panNumber = watch("panNumber");
      const panCardPhoto = watch("panCardPhoto")?.[0];
      const panRegex = /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/;
      if (!panNumber || !panRegex.test(panNumber)) return false;
      if (!panCardPhoto) return false;
    }
    if (!watch("userPhoto")?.[0] && !image) return false;
    valid = true;
    return valid;
  };

  const generateQr = async () => {
    try {
      const uuid = localStorage.getItem("uuid");
      const tokenRes = await axios.get(
        `${WEBSERVICE}user/getScannerToken?uuid=${uuid}`,
        { headers: { Authorization: "BEARER " + localStorage.getItem("access_token") } }
      );
      console.log("tokenRes", tokenRes);
      if (tokenRes.data.error.error_data !== 0) {
        showToast("error", tokenRes.data.error.error_msg);
      } else {
        setCount(300);
        const token = tokenRes.data.token;
        const encodedKey = `${window.location.origin}/mobile-capture/${btoa(uuid)}/${btoa(token)}`;
        setTwoFactorAuthKey(encodedKey);
        setShowQR(true);
      }
    } catch (err) {
      showToast("error", "Something went wrong");
    }
  };

  const getUserPhotoFromApi = async () => {
    const imageUrl = `${WEBSERVICE}user/${localStorage.getItem("uuid")}/${userDetails?.country}/file/user_photo.png?access_token=${localStorage.getItem("access_token")}`;
    try {
      const base64Data = await getBase64Image(imageUrl);
      const cleanedBase64 = base64Data.replace("data:application/octet-stream;base64,", "");
      console.log("base64Data", base64Data);
      if (!cleanedBase64) return;
      setImage(base64Data);
      setShowQR(false);
      setValue("userPhoto", null);
      const blobData = dataURItoBlob(base64Data);
    } catch (error) {
      console.error("Error fetching user photo:", error);
    }
  };

  const getBase64Image = (url) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () { resolve(reader.result); };
        reader.onerror = reject;
        reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = reject;
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    });
  };

  return (
    <>
      {steps === 7 && (
        <Box sx={card}>
          {/* Step Header */}
          <Box sx={stepHeader}>
            <Box sx={{ ...stepBadge, backgroundColor: alpha(btncolor || "#1976d2", 0.12), color: btncolor }}>
              <PersonOutlineOutlinedIcon sx={{ fontSize: 18 }} />
            </Box>
            <Box>
              <Typography sx={stepTitle}>Photo & Identity Submission</Typography>
              <Typography sx={stepCaption}>
                Upload your photo{(userDetails?.country === "India" || userDetails?.country === "IN") ? " and PAN card details" : ""}
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ borderColor: "rgba(125,125,125,0.13)", mb: 3 }} />

          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3}>
              {/* PAN details (India only) */}
              {(userDetails?.country === "India" || userDetails?.country === "IN") && (
                <>
                  <Grid size={{ xs: 12, md: 5 }}>
                    <Typography sx={fieldLabel}>PAN Card Photo *</Typography>
                    <Box sx={uploadCard}>
                      <Box sx={uploadIconRow}>
                        <UploadFileOutlinedIcon sx={{ fontSize: 16, color: btncolor, opacity: 0.8 }} />
                        <Typography sx={uploadHintInner}>Click to select file</Typography>
                      </Box>
                      <input
                        type="file"
                        style={fileInputStyle}
                        onChange={(e) => { setValue("panCardPhoto", e.target.files); trigger("panCardPhoto"); }}
                        {...register("panCardPhoto", {
                          required: "PAN card photo is required",
                          validate: validateFile,
                        })}
                      />
                    </Box>
                    {errors.panCardPhoto && <Typography sx={errorText}>{errors.panCardPhoto.message}</Typography>}
                    <Typography sx={hintText}>
                      Only valid government-issued documents. Accepted: .PNG, .JPEG, .DOC, .DOCX, .JFIF, .HEIC, .PDF, .BMP — MAX 6 MB
                    </Typography>
                  </Grid>

                  <Grid size={{ xs: 12, md: 5 }}>
                    <Typography sx={fieldLabel}>PAN Number *</Typography>
                    <Box sx={modernInputWrap}>
                      <input
                        type="text"
                        autoComplete="off"
                        maxLength={10}
                        style={modernInput}
                        placeholder="e.g. ABCDE1234F"
                        {...register("panNumber", {
                          required: "PAN Number is required",
                          pattern: {
                            value: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
                            message: "PAN must be 5 uppercase letters, followed by 4 digits, followed by 1 uppercase letter",
                          },
                        })}
                        onInput={(e) => { e.target.value = e.target.value.toUpperCase().slice(0, 10); }}
                      />
                    </Box>
                    {errors.panNumber && <Typography sx={errorText}>{errors.panNumber.message}</Typography>}
                    <Typography sx={hintText}>
                      Enter your 10-character PAN (e.g., ABCDE1234F). Must contain 5 letters, 4 digits, and 1 letter.
                    </Typography>
                  </Grid>
                </>
              )}

              {/* User Photo section */}
              <Grid size={{ xs: 12, md: 6 }}>
                <Typography sx={fieldLabel}>User Photo</Typography>

                {/* Upload file option */}
                <Box sx={{ mb: 2 }}>
                  <Typography sx={optionLabel}>Option 1 — Upload from device</Typography>
                  <Box sx={uploadCard}>
                    <Box sx={uploadIconRow}>
                      <UploadFileOutlinedIcon sx={{ fontSize: 16, color: btncolor, opacity: 0.8 }} />
                      <Typography sx={uploadHintInner}>Click to select file</Typography>
                    </Box>
                    <input
                      type="file"
                      style={fileInputStyle}
                      onClick={(e) => {
                        setImage(null);
                        const fileList = e.target.files;
                        setValue("userPhoto", fileList);
                      }}
                      {...register("userPhoto", {
                        validate: image ? true : validateFilePNGJPEG,
                      })}
                    />
                  </Box>
                  {!image && errors.userPhoto && <Typography sx={errorText}>{errors.userPhoto.message}</Typography>}
                </Box>

                {/* Webcam option */}
                <Box sx={{ mb: 2 }}>
                  <Typography sx={optionLabel}>Option 2 — Capture from webcam</Typography>
                  <ContainedButton
                    onClick={() => (setShow(true), setValue("userPhoto", null))}
                    sx={{ height: 44, borderRadius: "10px", textTransform: "none", fontWeight: 600, display: "flex", alignItems: "center", gap: 0.75 }}
                  >
                    <PhotoCameraOutlinedIcon sx={{ fontSize: 18 }} />
                    Capture a photo
                  </ContainedButton>
                </Box>

                {/* Mobile QR option */}
                <Box>
                  <Typography sx={optionLabel}>Option 3 — Capture from mobile device</Typography>
                  <ContainedButton
                    onClick={generateQr}
                    sx={{ height: 44, borderRadius: "10px", textTransform: "none", fontWeight: 600, display: "flex", alignItems: "center", gap: 0.75 }}
                  >
                    <QrCodeOutlinedIcon sx={{ fontSize: 18 }} />
                    Scan QR
                  </ContainedButton>
                </Box>
              </Grid>

              {/* Preview */}
              <Grid size={{ xs: 12, md: 6 }}>
                {image && !show && (
                  <Box sx={{ borderRadius: "12px", overflow: "hidden", border: "1px solid rgba(125,125,125,0.2)", maxWidth: 320, mt: { xs: 0, md: 3 } }}>
                    <img src={image} alt="Captured" style={{ width: "100%", display: "block" }} />
                  </Box>
                )}
              </Grid>

              {/* Instruction */}
              <Grid size={{ xs: 12 }}>
                <Box sx={{ p: 2, borderRadius: "10px", backgroundColor: "rgba(125,125,125,0.06)", border: "1px solid rgba(125,125,125,0.15)" }}>
                  <Typography sx={{ fontSize: "0.78rem", color: "var(--text-color)", opacity: 0.65, lineHeight: 1.7 }}>
                    Please upload a photo without wearing any hats, masks or glasses and holding your ID Proof, Address Proof Document and a sheet of Paper with the Text — 'Only for trading cryptocurrencies on {brokerBasicInfo?.exchange}.' Ensure all documents are clearly visible in photo. Accepted: .PNG, .JPEG — MAX 6 MB
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Box sx={actionRow}>
              <ContainedButton
                variant="contained"
                onClick={() => handleBack()}
                sx={{ ...submitBtn, opacity: 0.85 }}
              >
                Back
              </ContainedButton>
              <ContainedButton
                type="submit"
                variant="contained"
                sx={submitBtn}
              >
                Submit
              </ContainedButton>
            </Box>
          </form>

          {/* Webcam Modal */}
          <ModalContent open={show} onClose={handleClose}>
            {image ? (
              <div>
                <img src={image} alt="Captured" style={{ width: "100%" }} />
                <ContainedButton onClick={() => setImage(null)} style={{ marginRight: "10px" }}>
                  Take Another
                </ContainedButton>
                <ContainedButton onClick={() => setShow(false)}>Submit</ContainedButton>
              </div>
            ) : (
              <div style={{ position: "relative" }}>
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/png"
                  videoConstraints={{ facingMode: "user" }}
                  style={{ width: "100%" }}
                />
                <canvas
                  ref={canvasRef}
                  style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                />
              </div>
            )}
            {!faceDetected && (
              <div style={{ position: "absolute", top: 10, left: 10, backgroundColor: "rgba(255, 0, 0, 0.8)", color: "#fff", padding: "10px", borderRadius: "8px", fontWeight: "bold" }}>
                No face detected. Please adjust your position.
              </div>
            )}
            {!image && faceDetected && (
              <ContainedButton onClick={() => capturePhoto()} style={{ marginTop: "10px" }}>
                Snap Photo
              </ContainedButton>
            )}
          </ModalContent>

          {/* QR Code Modal */}
          <ModalContent open={showQR} onClose={handleCloseQRModal} width="xs">
            <QRCode
              value={twoFactorAuthKey}
              style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 auto" }}
            />
            <p className="pt-2" style={{ color: "#999898" }}>
              Your QR code will expire in {count} seconds
            </p>
            {count === 0 && (
              <ContainedButton onClick={generateQr}>Generate QR</ContainedButton>
            )}
          </ModalContent>
        </Box>
      )}

      {steps > 7 && <IDTier2 />}
    </>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const card = {
  backgroundColor: "var(--body-color-less)",
  borderRadius: "16px",
  border: "1px solid rgba(125,125,125,0.15)",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 10px 25px rgba(0,0,0,0.06)",
  p: { xs: 2.5, md: 3 },
};

const stepHeader = {
  display: "flex",
  alignItems: "center",
  gap: 1.5,
  mb: 2.5,
  flexWrap: "wrap",
};

const stepBadge = {
  width: 44,
  height: 44,
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const stepTitle = {
  fontSize: "1rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
};

const stepCaption = {
  fontSize: "0.78rem",
  color: "var(--text-color)",
  opacity: 0.55,
  mt: 0.2,
};

const fieldLabel = {
  fontSize: "0.72rem",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  color: "var(--text-color)",
  opacity: 0.55,
  mb: 0.5,
};

const optionLabel = {
  fontSize: "0.75rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.5,
  mb: 0.75,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
};

const uploadCard = {
  border: "2px dashed rgba(125,125,125,0.3)",
  borderRadius: "10px",
  p: 1.5,
  mt: 0,
  backgroundColor: "var(--body-color-less2)",
};

const uploadIconRow = {
  display: "flex",
  alignItems: "center",
  gap: 0.75,
  mb: 0.75,
};

const uploadHintInner = {
  fontSize: "0.75rem",
  color: "var(--text-color)",
  opacity: 0.5,
};

const fileInputStyle = {
  width: "100%",
  color: "var(--text-color)",
  fontSize: "0.85rem",
};

const modernInputWrap = {
  border: "1px solid rgba(125,125,125,0.25)",
  borderRadius: "10px",
  backgroundColor: "var(--body-color-less2)",
  mt: 0.5,
  overflow: "hidden",
};

const modernInput = {
  width: "100%",
  padding: "13px 14px",
  fontSize: "0.9rem",
  background: "transparent",
  border: "none",
  outline: "none",
  color: "var(--text-color)",
  boxSizing: "border-box",
};

const hintText = {
  fontSize: "0.72rem",
  color: "var(--text-color)",
  opacity: 0.45,
  mt: 0.75,
  lineHeight: 1.5,
};

const errorText = {
  fontSize: "0.72rem",
  color: "#ef4444",
  mt: 0.5,
};

const actionRow = {
  mt: 3.5,
  pt: 2.5,
  borderTop: "1px solid rgba(125,125,125,0.12)",
  display: "flex",
  gap: 1.5,
};

const submitBtn = {
  height: 48,
  px: 4,
  borderRadius: "10px",
  fontWeight: 700,
  fontSize: "0.88rem",
  textTransform: "none",
};

export default IdentityVerificationPAN;
